import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image'
import Col from 'react-bootstrap/Col';
import { Fancybox } from "@fancyapps/ui"
 

function AboutComponent() {
    
      return (
        <Container fluid>
          <Row>
            <h2>О приложении </h2>
            
           
          </Row>

            
         


 
        </Container>
      );
    
};
export default AboutComponent;


